import { Component, OnInit, OnDestroy } from '@angular/core';
import { CartService } from '../cart.service';
import { MetaDataService } from '../metadata.service';
import { NGXLogger } from 'ngx-logger';

@Component({
  selector: 'tea-shop-fe-checkout',
  standalone: false,
  templateUrl: './checkout.component.html',
  styleUrl: './checkout.component.css'
})
export class CheckoutComponent implements OnInit, OnDestroy {
  sessionId: string | null = null;
  errors: string[] = [];
  isLoading = true;

  checkout: any = null;

  constructor(
    private cartService: CartService,
    private metaDataService: MetaDataService,
    private logger: NGXLogger
  ) { 
    this.metaDataService.updateMetadata({
      title: 'Checkout',
      image: '/assets/contact/sencha-logo.png',
    });
  }

  ngOnDestroy() {
    if (this.checkout) {
      this.logger.info('Unmounting checkout');
      this.checkout.destroy();
    }
  }

  ngOnInit() {
    this.cartService.createCheckoutSession().subscribe({
      next: async (session) => {
        this.logger.info(`Checkout init`, session);
        this.sessionId = session.sessionId;
        this.isLoading = false;
        try {
          this.checkout = await this.cartService.initialiseEmbeddedCheckout(this.sessionId);
          this.checkout.mount('#checkout')
        } catch (error: any) {
          this.logger.error('An error occurred while initialising the embedded checkout:', error);
          this.errors.push(error.message);
        }
      },
      error: (error) => {
        this.logger.error('An error occurred while creating a checkout session:', error);
        this.errors.push('An error occurred while creating a checkout session. Please try again shortly.');
        this.isLoading = false;
      }
    });
  }
}
